var _path, _ellipse, _g, _path2, _path3, _path4, _ellipse2, _path5, _ellipse3, _ellipse4, _path6, _path7, _ellipse5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWithdrawSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 133,
    viewBox: "0 0 177 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149 31.7045C153.409 32.1301 162.631 30.7196 164.248 21.673C165.865 12.6264 170.188 10.1216 172.147 10",
    stroke: "#F3603F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.0817,
    cy: 64.6615,
    rx: 44.0817,
    ry: 43.7653,
    fill: "#53B175"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.626 64.6614C135.626 85.2366 118.824 101.928 98.0827 101.928C77.3411 101.928 60.5391 85.2366 60.5391 64.6614C60.5391 44.0862 77.3411 27.3944 98.0827 27.3944C118.824 27.3944 135.626 44.0862 135.626 64.6614Z",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.671 55.0866C117.671 56.2783 117.2 57.4289 116.344 58.2508L96.4331 77.3999C95.5339 78.2217 94.335 78.7149 93.0933 78.7149C91.8516 78.7149 90.6526 78.2217 89.7963 77.3999L79.8196 67.8253C78.9632 67.0035 78.4922 65.8529 78.4922 64.6612C78.4922 63.4695 79.006 62.36 79.8624 61.4971C80.7616 60.6752 81.9177 60.2232 83.1594 60.1821C84.4011 60.1821 85.5572 60.6341 86.4564 61.456L93.0933 67.8253L109.707 51.8814C110.606 51.0596 111.762 50.6075 113.004 50.6075C114.246 50.6486 115.402 51.1007 116.301 51.9636C117.157 52.7854 117.671 53.8949 117.671 55.0866Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152.705 108.427C156.82 109.607 164.776 114.092 163.679 122.59",
    stroke: "#F7B23B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 98.7194C8.31505 101.081 21.9293 102.774 25.8661 90.6583M25.8661 90.6583C26.4402 87.3199 25.8661 80.7163 18.977 81.0094C17.6647 84.2257 17.2053 90.6583 25.8661 90.6583ZM25.8661 90.6583C28.7366 91.1876 35.4125 90.6827 39.1523 84.4293",
    stroke: "#6E89FA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 132.216,
    cy: 128.805,
    rx: 4.22533,
    ry: 4.19501,
    fill: "#637BFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M175.884 62.3748C175.884 64.4121 174.22 66.0698 172.159 66.0698C170.098 66.0698 168.434 64.4121 168.434 62.3748C168.434 60.3375 170.098 58.6798 172.159 58.6798C174.22 58.6798 175.884 60.3375 175.884 62.3748Z",
    stroke: "#C05EFD"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.086,
    cy: 4.59389,
    rx: 4.62709,
    ry: 4.59389,
    fill: "#53B175"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.225,
    cy: 12.3477,
    rx: 2.44361,
    ry: 2.42608,
    fill: "#F3603F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0648 40.2517C47.0648 42.3203 45.3748 44.0033 43.2824 44.0033C41.19 44.0033 39.5 42.3203 39.5 40.2517C39.5 38.1831 41.19 36.5 43.2824 36.5C45.3748 36.5 47.0648 38.1831 47.0648 40.2517Z",
    stroke: "#F7B23B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4098 115.018C78.4098 117.32 76.5289 119.193 74.201 119.193C71.8731 119.193 69.9922 117.32 69.9922 115.018C69.9922 112.715 71.8731 110.843 74.201 110.843C76.5289 110.843 78.4098 112.715 78.4098 115.018Z",
    stroke: "#53B175"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.24959,
    ry: 2.23344,
    transform: "matrix(-1 0 0 1 119.077 123.994)",
    fill: "#53B175"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 55.5391,
    y: 25.3944,
    width: 85.0872,
    height: 84.534,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawSuccess);
export default __webpack_public_path__ + "static/media/withdraw-success.f5df5be8f68ba74d62cfdf27f8b9d67a.svg";
export { ForwardRef as ReactComponent };